export default __webpack_public_path__ + "static/media/tebex.6f833a4f.svg";